module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Music-c45e192ca2718c9d0b2180ceac28d2b3.svg";